<script>
import CcModestButton from '@/components/elements/CcModestButton';

export default {
    name: 'IHaveNoToken',
    components: { CcModestButton },
    computed: {},
    methods: {
        idontHaveToken() {
            this.$router.push({ name: 'signupInformation' }).catch(() => { alert('Error ') });
        }
    }
}
</script>

<template>
    <div class="no-digid">
        <CcModestButton
            @select="idontHaveToken"
            :label="$t('components.token.dontHaveToken')"
            :margin-top="true"/>
    </div>
</template>

<style lang="scss" scoped>
@import "@/styles/variables/index";

</style>
